// extracted by mini-css-extract-plugin
module.exports = {"form":"ptplp","submit":"_69jpk"};